import { companyApis } from '@apis/dashboard/companyApis';
import { useMutation } from '@hooks/useMutation';
import type { PatchChecklist } from '@models/Checklist';
import { useQueryClient } from '@tanstack/react-query';
import { FormError } from '@utils/errors';

export const usePatchCompanyChecklist = (id: number) => {
  const queryClient = useQueryClient();

  return useMutation(
    async (body: PatchChecklist) => {
      const response = await companyApis.patch('/dashboard/company/{id}/checklist/', {
        path: { id },
        body,
      });
      if (response[400]) {
        throw new FormError('PatchCompanyChecklist', response[400]);
      }
      return response[200]!;
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries([`/dashboard/company/${id}/checklist/`]);
      },
    },
  );
};
